import React from 'react'
import { DetailPageLayout } from '@/components/DetailPageLayout'
import { RenderBlocks, type Block } from '@/blocks/RenderBlocks'

export type DetailPageLayoutBlockProps = {
  breadcrumbs?: Array<{ label: string; href?: string | null }> | null
  main?: Block[] | null
  sidebar?: Block[] | null
  blockType: 'detailPageLayout'
}

export const DetailPageLayoutBlock: React.FC<DetailPageLayoutBlockProps> = ({
  breadcrumbs,
  main,
  sidebar,
}) => {
  const crumbs = breadcrumbs?.map((c) => ({ label: c.label, href: c.href ?? undefined })) ?? []
  const sidebarSlot = sidebar && sidebar.length > 0 ? <RenderBlocks blocks={sidebar} /> : undefined
  return (
    <DetailPageLayout
      breadcrumbs={crumbs}
      main={<RenderBlocks blocks={main ?? []} />}
      sidebar={sidebarSlot}
    />
  )
}
